import axiosInstance from '../axiosConfigCMS';

export default {
  async getContent() {
    const response = await axiosInstance.get('/shipping-page');
    return response.data;
  },
};
